import React from 'react';

export function speedBadge(max: number, warning: number): React.ReactElement {
  if (max >= warning) return <span className="badge badge--red">Speeding {max} km/h</span>;
  return <span className="text--success">{max} km/h</span>;
}
